export default {"src":"/_next/static/media/Docker.fd249fdf.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};